import { render, staticRenderFns } from "./ActionRecord.vue?vue&type=template&id=360301fb&"
import script from "./ActionRecord.vue?vue&type=script&lang=js&"
export * from "./ActionRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports